import script from "./CropperImage.vue?vue&type=script&lang=ts&setup=true"
export * from "./CropperImage.vue?vue&type=script&lang=ts&setup=true"

import "./CropperImage.vue?vue&type=style&index=0&id=d16fda2c&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d16fda2c"]])

export default __exports__